import _getIterator from 'babel-runtime/core-js/get-iterator';
import _extends from 'babel-runtime/helpers/extends';
import _typeof from 'babel-runtime/helpers/typeof';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import React from 'react';
import StaticContainer from 'react-static-container';
import PropTypes from 'prop-types';

import mergeRouteParams from './utils/mergeRouteParams';

let propTypes = {
    children: PropTypes.element.isRequired,
    queries: PropTypes.object.isRequired,
    routerProps: PropTypes.object.isRequired
};

let contextTypes = {
    queryAggregator: PropTypes.object.isRequired
};

function RouteContainer(_ref, _ref2) {
    let queries = _ref.queries;
    let routerProps = _ref.routerProps;
    let children = _ref.children;

    let extraProps = _objectWithoutProperties(_ref, ['queries', 'routerProps', 'children']);

    let queryAggregator = _ref2.queryAggregator;
    let key = routerProps.key;
    let route = routerProps.route;
    let routes = routerProps.routes;


    let params = {};
    for (var _iterator = routes, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator); ;) { //eslint-disable-line no-var,no-redeclare
        let _ref3;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref3 = _iterator[_i++];
        } else {
            _i = _iterator.next();

            if (_i.done) break;
            _ref3 = _i.value;
        }

        let ancestorRoute = _ref3;

        params = mergeRouteParams(params, ancestorRoute, routerProps);

        if (ancestorRoute === route) {
            break;
        }
    }

    let renderArgs = queryAggregator.getRenderArgs(route, key, queries, params);

    let props = renderArgs.props;
    let render = route.render;

    if (render && (typeof render === 'undefined' ? 'undefined' : _typeof(render)) === 'object') {
        render = render[key];
    }

    // The below is largely copied from RelayReadyStateRenderer.

    let element = void 0;
    if (render) {
        element = render.call(route, _extends({}, renderArgs, {
            props: props && _extends({}, routerProps, extraProps, params, props),
            routerProps: _extends({}, routerProps, extraProps),
            element: children
        }));
    } else if (props) {
        // The child already has routerProps, so just inject the additional props.
        element = React.cloneElement(children, _extends({}, extraProps, params, props));
    }

    let shouldUpdate = void 0;
    if (element === undefined) {
        element = null;
        shouldUpdate = false;
    } else {
        shouldUpdate = true;
    }

    return React.createElement(
        StaticContainer,
        { shouldUpdate: shouldUpdate },
        element
    );
}

RouteContainer.contextTypes = contextTypes;

export default RouteContainer;
